import * as firebase from 'firebase/app'

export default {
    getUserByEmail(params) {
        return firebase.firestore().collection('user')
        .where('email', '==', params.userEmail)
        .get()
    },
    getUserDisplayname(params) {
        return firebase.firestore().collection('user')
        .where('displayname', '==', params.id)
        .get()
    },
    getUserLists(params) {
        return firebase.firestore().collection('user')
        .doc(params.userId).collection('Lists')
        .get()
    },
    createUserList(params) {
        return firebase.firestore().collection('user')
        .doc(params.id).collection('Lists').doc(params.listName)
        .set({'experiences': []})
    },
    deleteUserList(params) {
        return firebase.firestore().collection('user')
        .doc(params.userId).collection('Lists').doc(params.listName)
        .delete()
    },
    addExperienceToUserList(params) {
        return firebase.firestore().collection('user')
        .doc(params.id).collection('Lists').doc(params.listName)
        .update({'experiences': firebase.firestore.FieldValue.arrayUnion(params.experienceId)})
    },
    deleteExperienceFromUserList(params) {
        return firebase.firestore().collection('user')
        .doc(params.id).collection('Lists').doc(params.listName)
        .update({'experiences': firebase.firestore.FieldValue.arrayRemove(params.experienceId)})
    },
    getAreasOrdered(params) {
        return firebase.firestore().collection('areas')
        .orderBy('name', params.orderBy)
        .get()
    },
    getAllUsers(params) {
        return firebase.firestore().collection('user')
        .orderBy('email', params.orderBy)
        .get()
    },
    exportUserList(params) {
        return firebase.firestore().collection('user')
        .doc(params.id)
        .collection('Lists').doc(params.listName)
        .set({'experiences': params.experiencesID})
    }
}